/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    confirmValidationKeyButton: {
        innerHTML: "Vérifier la clé"
    },
    confirmValidationKeyTitle: {
        innerText: "Vérification de la clé d'authentification"
    },
    keyInput: {
        placeholder: "clé"
    },
    loginInput: {
        placeholder: "identifiant"
    }
};